import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, patch, post, put } from "helpers/api_helper"
import { GET_DROPDOWN_API, GET_JOB_TITLES } from "helpers/url_helper"

export const getDropdownData = createAsyncThunk(
  GET_DROPDOWN_API,
  async payload => {
    const response = await post(GET_DROPDOWN_API, payload)
    return response
  }
)

export const getJobTitlesList = createAsyncThunk(
  GET_JOB_TITLES,
  async payload => {
    const response = await get(GET_JOB_TITLES, payload)
    return response
  }
)
